export enum AggregatedEmailStatusCode {
    Failed = 'Failed',
    Queued = 'Queued',
    Delivered = 'Delivered',
    Unsent = 'Unsent'
}
